import { authHeader, accountHeader, BASE_URL, handleResponse, handleResponseBlob } from '@helpers/api';

export const surveyService = {
    getAll,
    getAvailablePlatforms,
    getReviewTags,
    getReviewTagDefaults,
    createReviewTag,
    renameReviewTag,
    deleteReviewTag,
    createEmptySurvey,
    deleteSurvey,
    editSurvey,
    getSurveyImage,
    uploadQRLogoImage,
};

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates`, requestOptions).then(handleResponse);
}

// Available review platforms for a survey template. Pass locationId for a location template, or brandId
// for a brand template (union across the brand's locations). Single source of truth shared with the
// backend's save-time validation.
function getAvailablePlatforms({ locationId, brandId } = {}) {
    const params = new URLSearchParams();
    if (locationId) params.set('locationId', locationId);
    if (brandId) params.set('brandId', brandId);
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(
        `${BASE_URL}api/surveys/survey-templates/available-platforms?${params.toString()}`,
        requestOptions,
    ).then(handleResponse);
}

function getReviewTags() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/review-tags`, requestOptions).then(handleResponse);
}

function getReviewTagDefaults() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/review-tags/defaults`, requestOptions).then(handleResponse);
}

function createReviewTag(name) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ name }),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/review-tags/custom`, requestOptions).then(handleResponse);
}

function renameReviewTag(id, name) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify({ name }),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/review-tags/custom/${id}`, requestOptions).then(
        handleResponse,
    );
}

function deleteReviewTag(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/review-tags/custom/${id}`, requestOptions).then(
        handleResponse,
    );
}

function createEmptySurvey() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/empty`, requestOptions).then(handleResponse);
}

function editSurvey(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates`, requestOptions).then(handleResponse);
}

function deleteSurvey(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/${id}`, requestOptions).then(handleResponse);
}

function getSurveyImage(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/generate-qr`, requestOptions).then(handleResponseBlob);
}

function uploadQRLogoImage(data, surveyId) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
            ...accountHeader(),
        },
        body: data,
    };
    return fetch(`${BASE_URL}api/surveys/survey-templates/${surveyId}/upload-logo`, requestOptions).then(
        handleResponse,
    );
}
